import React from 'react';
var RouteIcon = function (_a) {
    var route = _a.route, color = _a.color, textColor = _a.textColor;
    return (React.createElement("div", { style: {
            display: 'flex',
            minWidth: 160,
            height: 80,
            fontSize: 60,
            fontWeight: 700,
            background: color,
            borderRadius: 16,
            color: textColor,
            alignItems: 'center',
            justifyContent: 'center',
        } }, route));
};
export default RouteIcon;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/RouteIcon.tsx
// module id = 1840
// module chunks = 0